let selectCallback = function(variant, selector) {
    console.log(variant)
    if (document.querySelector('.product-checkout-btns-quick')){
        document.querySelector('.product-checkout-btns-quick').href= `/cart/${variant.id}:${document.getElementById('count').value}`
    }
    // for (const key in variant.options) {
    //     document.querySelector(`[data-value="${variant.options[key]}-${key}"]`).classList.add('active-option');
    //     document.querySelector(`[data-holder="${key}"]`).innerHTML = variant.options[key];

    //     if (variant.options[key] == "No Engraving" ){
    //         document.querySelector('.custom-product__meta-option-engraving input').checked = false;
    //         if (document.querySelector('.engarving_text')){
    //             document.querySelector('.engarving_text').style.display = 'none'
    //         }
    //         document.querySelector('.engraving-info').style.display = 'none'
    //         document.querySelector('.engraving-info input').value = ''
    //     }

    //     if (variant.options[key] == "Engraving" ){
    //         document.querySelector('.custom-product__meta-option-engraving input').checked = true;
    //         if (document.querySelector('.engarving_text')){
    //             document.querySelector('.engarving_text').style.display = 'block'
    //         }
    //         document.querySelector('.engraving-info').style.display = 'block'
    //     }
    // }
    
    // if (variant.featured_media){
    //     swiper2.slideTo(variant.featured_media.position -1);
    // }
    
    document.querySelector('.custom-product__meta-main-price').innerHTML = Shopify.formatMoney(variant.price);
    if ( variant.compare_at_price > variant.price ){
        document.querySelector('.custom-product__meta-sale-price').innerHTML = Shopify.formatMoney(variant.compare_at_price);
    } else {
        document.querySelector('.custom-product__meta-sale-price').innerHTML = ``;
    }
    
    // if (variant.available){
    //     document.querySelector('.add-to-cart-btn').innerHTML = `Add to cart`;
    //     document.querySelector('.product-checkout-btns').classList.remove('sold-out');
    // } else {
    //     document.querySelector('.add-to-cart-btn').innerHTML = `Sold out`;
    //     document.querySelector('.product-checkout-btns').classList.add('sold-out');
    // }

}
    
    
function toggleDropDown(selector){
    document.querySelectorAll('.custom-product__dropdown').forEach(item=>{
        if (item.dataset.opt != selector){
            item.classList.remove('custom-product__meta-option-wrapper--opened')
        }
    });
    document.querySelector(`[data-opt="${selector}"]`).classList.toggle('custom-product__meta-option-wrapper--opened');
}

function setSelector(value, looper, option){
    document.querySelectorAll('.single-option-selector')[looper].value = value;
    document.querySelectorAll('.single-option-selector')[looper].dispatchEvent(new Event('change'));

    document.querySelectorAll(`[data-options="${option}-${looper}"]`).forEach(item=>{
        item.classList.remove('active-option')
    })
    document.querySelector(`[data-value="${value}-${looper}"]`).classList.add('active-option');
}

if (document.querySelector('.custom-product__meta-option-engraving')){
    document.querySelector('.custom-product__meta-option-engraving label').addEventListener('click', function(){
        if (document.querySelector('.custom-product__meta-option-engraving label input').checked){
            let looper = document.querySelector('.custom-product__meta-option-engraving').dataset.loop;
            console.log(looper);
            document.querySelectorAll('.single-option-selector')[looper].value = 'Engraving';
            document.querySelectorAll('.single-option-selector')[looper].dispatchEvent(new Event('change'));
        
        } else {
            let looper = document.querySelector('.custom-product__meta-option-engraving').dataset.loop;
            console.log(looper);
            document.querySelectorAll('.single-option-selector')[looper].value = 'No Engraving';
            document.querySelectorAll('.single-option-selector')[looper].dispatchEvent(new Event('change'));
        }
    })
}

let count = 1;
let countEl = document.getElementById("count");
function plus(){
    count++;
    countEl.value = count;
}
function minus(){
  if (count > 1) {
    count--;
    countEl.value = count;
  }  
}
